module.exports = __webpack_public_path__ + "fe19acfc2958a9e2a9f6489cb336c3ac.png";